import GlobalDispatcher from "../events/GlobalDispatcher";
import EntryPoint from "../EntryPoint";

export default class BaseSlotWinningsController {
    constructor() {

        this.winningData = null;
        this.currentWinId = 0;

        this.init();
        this.addListeners();
    }

    init() {

    }

    addListeners() {

    }

    showNextWin() {
        if(this.currentWinId === this.winningData.length) {
            GlobalDispatcher.dispatch('winningsController:allWinningsComplete');
        }
        let index = this.currentWinId % this.winningData.length;
        let currentWinData = this.winningData[index];
        if (currentWinData) {
            GlobalDispatcher.dispatch('winningsController:slowWin', currentWinData);
            this.currentWinId++;
            this.timeout = setTimeout(() => {
                this.showNextWin();
            }, 1000);
        }
    }

    start() {
        this.currentWinId = 0;
        this.winningData = [];
        if(EntryPoint.GameModel.winnings.lines) {
            this.winningData = this.winningData.concat(EntryPoint.GameModel.winnings.lines);
        }
        if(EntryPoint.GameModel.winnings.scatters) {
            this.winningData = this.winningData.concat(EntryPoint.GameModel.winnings.scatters);
        }
        this.showNextWin();
    }

    stop() {
        clearTimeout(this.timeout);
    }

    reset() {
        this.currentWinId = 0;
        this.winningData = [];
        clearTimeout(this.timeout);
    }
}